export const SECTION_CARD_CLASS =
  "rounded-[12px] bg-white p-10 shadow-[0_0_32px_rgba(0,0,0,0.09)]";

// Common default values
export const COMMON_DEFAULT_VALUES = {
  website: "",
  company_email: "",
  company_phone: "",
  company_street_address: "",
  company_country_id: 0,
  company_state_id: 0,
  company_city_id: 0,
  company_postal_code: "",
  tax_id: "",
  region_id: 0,
  timezone: "",
  first_name: "",
  last_name: "",
  corporate_email: "",
  designation: "",
  mobile_phone: "",
  work_phone_no: "",
  street_address: "",
  country_id: 0,
  state_id: 0,
  city_id: 0,
  postal_code: "",
  product: "",
  plan: "",
  billing_frequency: "",
  payment_mode: "",
  transaction_ref: "",
  date_of_payment: "",
  expiration_date: "",
  comment: "",
};

// Customer specific defaults
export const CUSTOMER_DEFAULT_VALUES = {
  ...COMMON_DEFAULT_VALUES,
  company_name: "",
  company_work_phone_no: "",
  position: "",
  msp_id: 0,
  plan_price_id: 0,
  no_of_licenses: "" as any,
  unit_price: "",
  total_paid_amount: 0,
  discount: 0,
};

// MSP specific defaults
export const MSP_DEFAULT_VALUES = {
  ...COMMON_DEFAULT_VALUES,
  organization_name: "",
  job_title: "",
  no_of_licenses: undefined,
  unit_price: "",
  total_paid_amount: 0,
  discount: 0,
  plan_price_id: 0,
  cognito_url: import.meta.env.VITE_DEFAULT_COGNITO_URL,
};
